export default {
  data() {
    return {
      searchOccurrences: 0,
      currentOccurrence: 0
    }
  },
  methods: {
    scrollToElement(element) {
      element.scrollIntoView({ behavior: 'smooth' })
    },
    goNearHighlight(element, next) {
      var list = $('[data-highlight]')
      var index = list.index($(element).closest('[data-highlight]'))
      var target = (index + (next ? 1 : -1)) % list.length
      if (target == -1) target = list.length - 1
      this.currentOccurrence = target + 1
      this.scrollToElement(list.eq(target)[0])
    },
    goFirstHightlight(){
      var target = $('[data-highlight]').first()[0]
      if (target) {
        this.currentOccurrence = 1
        this.scrollToElement(target)
      }
    },
    goLastHighlight() {
      var list = $('[data-highlight]')
      var target = list.last()[0]
      this.currentOccurrence = list.length
      this.scrollToElement(target)
    },
    resetOccurrences() {
      this.searchOccurrences = 0
      this.currentOccurrence = 0
    },
    calculateOccurrences() {
      this.searchOccurrences = $('[data-highlight]').length
    },
  },
  created() {
    var self = this
    $(document).on('click', '.highlight_first', function (event) {
      self.goFirstHightlight()
    })

    $(document).on('click', '.highlight_prev', function (event) {
      self.goNearHighlight(event.target, false)
    })

    $(document).on('click', '.highlight_next', function (event) {
      self.goNearHighlight(event.target, true)
    })

    $(document).on('click', '.highlight_last', function (event) {
      self.goLastHighlight()
    })
  }
}
